module.exports = __webpack_public_path__ + "img/Morocco.5ceafde8.svg";